(function($) {
	$(document).ready(function() {
	    $('.trigger-mobile-nav').on('click', function(e) {
	        e.preventDefault();
	        $('.main-nav').toggleClass('is-active');
	    });

	    $('.featured').flexslider({
	    	animation: 'fade',
	    	controlNav: false,
	    	prevText: '',
	    	nextText: '',
	    });
	});
})(jQuery);